/**
 * Angular imports.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Confirm modal.
 */
@Component({
  selector: 'app-confirm-card',
  templateUrl: './confirm-card.component.html',
  styleUrls: ['./confirm-card.component.scss']
})
export class ConfirmCardComponent {

  /**
   * Flag for show/hide.
   * banner image src
   * heading for the modal
   * paragraph for the modal
   * confirm text for the modal.
   */
  @Input() confirmPopup: boolean;
  @Input() banner: string;
  @Input() heading: string;
  @Input() paragraph: string;
  @Input() confirmText: string;

  /**
   * Emit the action outside.
   */
  @Output() confirmAction: EventEmitter<void> = new EventEmitter();

  /**
   * Emit the action outside.
   */
  emitConfirm(): void {
    this.confirmAction.emit();
  }
}
